import script from "./AccessDeny.vue?vue&type=script&setup=true&lang=js"
export * from "./AccessDeny.vue?vue&type=script&setup=true&lang=js"

import "./AccessDeny.vue?vue&type=style&index=0&id=8e26013a&scoped=true&lang=css"

import exportComponent from "C:\\xampp8\\htdocs\\rnd_2023_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8e26013a"]])

export default __exports__